import React, {useState, useEffect} from 'react'
import axios from 'axios'
import logo2 from './logo.png';



function Admin(){
    const [entries, setEntries] = useState([])

    const [title, setTitle] = useState('')

    const [author, setAuthor] = useState('')

    const [comment, setComment] = useState('')


    const [date, setDate] = useState('')

    const[doi, setDOI] = useState('')

    

    


    //const submitEntry =() =>{}

     useEffect(()=>
    {
        axios.get('https://jtvetapi.onrender.com/entries')
        .then(res=>setEntries(res.data))
        
        
    }, [])

    const submitEntry = () =>{ 
        axios.post('https://jtvetapi.onrender.com/entries', {title, author, date, doi})
        .then(()=>window.location.reload())
    }


return(
    
    <div className="App"
    
    
    >
         <img src={logo2} className="App-logo" alt="logo" />
        <h1>Journal of Technical and Vocational Education and Training</h1>
        <h2>Welcome Admin!</h2>
        <p><i>Enter Article details below</i></p>
        <form className=''>
         <input className='input' value ={title} onChange={e=>setTitle(e.target.value)} placeholder='Title'/>
        <br/>
        <textarea value ={author} onChange={e=>setAuthor(e.target.value)} placeholder="Author names"/>
        <br/>
        <input className='input' value={date} onChange={e=>setDate(e.target.value)} placeholder='Date'/>
        <br/>
        <textarea value ={comment} onChange={e=>setComment(e.target.value)} placeholder="Enter Abstract"/>
        <br/>
        <input className='input' type='url' value ={doi} onChange={e=>setDOI(e.target.value)} placeholder='Insert DOI link e.g. https://doi.org/10.1016/......'/>
        <br/>
        <br/>
        <button className='button' type="submit" onClick={submitEntry}>Submit</button>
       
        
        </form>
       <footer><small>Copyright &copy; 2025 Designed by | ISITEC</small></footer>
    </div>

)
}

export default Admin